import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { DialogTemplate } from '@core/models/models';

@Component({
  selector: 'caremoni-dialog-template',
  templateUrl: './dialog-template.component.html',
  styleUrls: ['./dialog-template.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DialogTemplateComponent implements OnInit {
  @Input() dialogTemplate: DialogTemplate = new DialogTemplate();
  @Output() closeModalHandler = new EventEmitter();
  isDisplay: boolean = false;
  constructor() { }

  ngOnInit(): void {
    this.isDisplay = true;
  }

  closeModal(){
    this.isDisplay = false;
    this.closeModalHandler.emit();
  }
}
